import { render } from "./NewVentaPage.vue?vue&type=template&id=3f60301b"
import script from "./NewVentaPage.vue?vue&type=script&lang=js"
export * from "./NewVentaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__